<div class="copyright-text">
    <span [innerHTML]="(data | async)?.content" class="copy-right-alignment"></span>
    <span>{{currentYear}}</span>
</div>